import { font } from '@cowprotocol/ui'

import styled from 'styled-components/macro'

export const InfoBannerTitle = styled.strong`
  ${font('FONT_SMALL_PLUS', 'semibold')}
`
